var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { appear: "", name: "slideFromBottom" } }, [
    _vm.isOpen
      ? _c(
          "div",
          {
            staticClass:
              "grid grid-cols-2 gap-4 lg:grid-cols-7 items-center cookie-bar-position z-cookie-bar w-9/10 p-8 shadow-lg bg-gray-100 rounded",
          },
          [
            _c("div", { staticClass: "col-span-5" }, [
              _vm._v(" " + _vm._s(_vm.$t("App.CookieBar.cookieMessage")) + " "),
            ]),
            _c(
              "button",
              {
                staticClass:
                  "text-white bg-blue-500 hover:text-white hover:bg-blue-750",
                on: { click: _vm.accept },
              },
              [_vm._v(" " + _vm._s(_vm.$t("App.CookieBar.acceptText")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass:
                  "text-white bg-blue-500 hover:text-white hover:bg-blue-750",
                on: { click: _vm.decline },
              },
              [_vm._v(" " + _vm._s(_vm.$t("App.CookieBar.declineText")) + " ")]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }